module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Preview & Setting")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs btn-edit",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.saveSort()
      }
    }
  }, [_vm._v("\n                Simpan Perubahan\n              ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Preview Konten")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "preview-content"
  }, [_c('div', {
    staticClass: "listdrag"
  }, [_c('span', {
    staticClass: "titleSection"
  }, [_vm._v("List Section")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove,
      "id": "dragAreaSectionContent"
    },
    model: {
      value: (_vm.sectionList),
      callback: function($$v) {
        _vm.sectionList = $$v
      },
      expression: "sectionList"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "id": "transGroupSection"
    }
  }, _vm._l((_vm.sectionList), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "dragItem"
    }, [(element.type === 'VIDEO') ? _c('i', {
      staticClass: "fa fa-play",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'SINGLE_BANNER') ? _c('i', {
      staticClass: "fa fa-picture-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'MULTIPLE_BANNER') ? _c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'EXERCISE') ? _c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'ARTICLE') ? _c('i', {
      staticClass: "fa fa-newspaper-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'TRYOUT_RESULT') ? _c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'ONGOING_TRYOUT') ? _c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                          " + _vm._s(element.name)), _c('br'), _vm._v("\n                          " + _vm._s(element.type) + "\n                        ")])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "phone",
    style: ({
      backgroundImage: 'url(' + _vm.logo + ')'
    }),
    attrs: {
      "id": "phoneArea"
    }
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "id": "menuDrag"
    },
    on: {
      "click": function($event) {
        _vm.menuMode = true
      }
    }
  }, [_c('div', {
    staticClass: "menuRow"
  }, _vm._l((_vm.submitMenu.slice(0, 4)), function(element) {
    return _c('div', {
      key: element.id,
      staticClass: "menuIteration"
    }, [_c('img', {
      staticClass: "iconMenu",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "captionMenu"
    }, [_vm._v("\n                        " + _vm._s(element.display_name) + "\n                      ")])])
  }), 0)]), _vm._v(" "), (!_vm.menuMode) ? _c('div', {
    staticClass: "listdragPhoneArea"
  }, [_c('div', {
    staticClass: "dumHeader"
  }, [_c('div', {
    staticClass: "dumWrapper"
  }, [_c('div', {
    staticClass: "centerFlex"
  }, [_c('img', {
    staticClass: "ticketIcon",
    attrs: {
      "src": _vm.ticket
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "ticketInteger"
  }, [_c('b', [_vm._v("315")])]), _vm._v(" "), _c('p', {
    staticClass: "dumSeeMore"
  }, [_vm._v("lihat detail >")])])]), _vm._v(" "), _c('div', {
    staticClass: "centerFlex"
  }, [_c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "haiFulan"
  }, [_c('b', [_vm._v("Hai Fulan,")])]), _vm._v(" "), _c('p', {
    staticClass: "gradeCapt"
  }, [_vm._v("Kelas 12")])]), _vm._v(" "), _c('img', {
    staticClass: "imagePP",
    attrs: {
      "src": _vm.pp
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "package-list"
  }, [_c('div', {
    staticClass: "alertTicket"
  }, [_c('span', [_vm._v("Kamu punya\n                        "), _c('b', {
    staticStyle: {
      "color": "#355eab"
    }
  }, [_vm._v("100 Paket Belajar")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#3cb54a"
    }
  })])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "draggable-1",
    attrs: {
      "move": _vm.onMove,
      "id": "dragAreaSection"
    },
    on: {
      "add": function($event) {
        return _vm.onSectionAdd($event)
      },
      "remove": function($event) {
        return _vm.onSectionRemove($event)
      }
    },
    model: {
      value: (_vm.submitList),
      callback: function($$v) {
        _vm.submitList = $$v
      },
      expression: "submitList"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "id": "transAreaSection"
    }
  }, _vm._l((_vm.submitList), function(element) {
    return _c('div', {
      key: element.id,
      staticClass: "draggable-3"
    }, [(element.type === 'SINGLE_BANNER') ? _c('div', {
      staticClass: "banner"
    }, [_c('div', {
      staticClass: "nameSingleBanner"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "imgSingleBanner",
      attrs: {
        "src": _vm._f("parsingContentIMG")(element.details[0].content)
      }
    })])]) : _vm._e(), _vm._v(" "), (element.type === 'MULTIPLE_BANNER') ? _c('div', {
      staticClass: "banner"
    }, [_c('div', {
      staticClass: "nameMultiBanner"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "fl"
      }, [_c('img', {
        staticClass: "imgMultiBanner",
        attrs: {
          "src": _vm._f("parsingContentIMG")(item.content)
        }
      })])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'ARTICLE') ? _c('div', {
      staticClass: "articleItem"
    }, [_c('div', {
      staticClass: "nameArticle"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "articleIteration"
      }, [_c('div', {
        staticClass: "articleWrapper"
      }, [_c('img', {
        staticClass: "imgArticle",
        attrs: {
          "src": _vm._f("parsingContentIMG")(item.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "articleText"
      }, [_c('p', {
        staticClass: "articleTitle"
      }, [_vm._v("\n                                    " + _vm._s(_vm._f("parsingTITLE")(item.content)) + "\n                                  ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm._f("parsingDESCRIPTION")(item.content)) + "\n                                  ")])])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'VIDEO') ? _c('div', {
      staticClass: "videoItem"
    }, [_c('div', {
      staticClass: "nameVideo"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "videoIteration"
      }, [_c('div', {
        staticClass: "videoWrapper"
      }, [_c('div', {
        staticClass: "videoThumbnail",
        style: ({
          backgroundImage: 'url(' + _vm.play + ')',
          height: '100px',
          width: '100px',
          backgroundRepeat: 'no-repeat',
          zIndex: 1,
          left: '45%',
          top: '15%',
          position: 'absolute',
        })
      }), _vm._v(" "), _c('img', {
        staticClass: "imgVideo",
        attrs: {
          "src": _vm._f("parsingThumbnail")(item.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "videoText"
      }, [_c('p', {
        staticClass: "videoTItle"
      }, [_vm._v("\n                                    " + _vm._s(_vm._f("parsingTITLE")(item.content)) + "\n                                  ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm._f("parsingDESCRIPTION")(item.content)) + "\n                                  ")])])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'ONGOING_TRYOUT') ? _c('div', {
      staticClass: "onTryoutItem"
    }, [_c('div', {
      staticClass: "onTryoutWrapper"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "onTryoutIteration"
      }, [_c('div', {
        staticClass: "onTryoutText"
      }, [_c('p', {
        staticClass: "onTryoutType"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOType")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "onTryoutName"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOName")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', [_c('i', {
        staticClass: "fa fa-calendar"
      }), _vm._v("  " + _vm._s(_vm._f("parsingTOTime")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "seeMoreOnTryout"
      }, [_vm._v("Lihat Detail")])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'TRYOUT_RESULT') ? _c('div', {
      staticClass: "resultItem"
    }, [_c('div', {
      staticClass: "resultWrapper"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "resultIteration"
      }, [_c('div', {
        staticClass: "resultText"
      }, [_c('p', {
        staticClass: "resultType"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOType")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "resultName"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOName")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', [_c('i', {
        staticClass: "fa fa-calendar"
      }), _vm._v("  " + _vm._s(_vm._f("parsingTOTime")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "resultSeeMore"
      }, [_vm._v("Lihat Hasil")])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'EXERCISE') ? _c('div', {
      staticClass: "exerciseItem"
    }, [_c('div', {
      staticClass: "exerciseName"
    }, [_c('b', [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('button', {
      staticClass: "exerciseIPA"
    }, [_vm._v("IPA")]), _vm._v(" "), _c('button', {
      staticClass: "exerciseIPS"
    }, [_vm._v("IPS")])]), _vm._v(" "), _vm._l((element.details.slice(
      0,
      1
    )), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "cardExerciseIteration"
      }, [_c('div', {
        staticClass: "exerciseContent"
      }, [_c('p', {
        staticClass: "exerciseMapel"
      }, [_vm._v(_vm._s(_vm.mapelExercise))]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.changeFormat(item.content))
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "exerciseButtonYuk"
      }, [_vm._v("\n                                Kerjakan Soal Yuk\n                              ")])])])
    })], 2) : _vm._e()])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.menuMode) ? _c('div', {
    staticClass: "listdragMenu"
  }, [_c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dumHeader"
  }, [_c('div', {
    staticClass: "dumWrapper"
  }, [_c('div', {
    staticClass: "centerFlex"
  }, [_c('img', {
    staticClass: "ticketIcon",
    attrs: {
      "src": _vm.ticket
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "ticketInteger"
  }, [_c('b', [_vm._v("315")])]), _vm._v(" "), _c('p', {
    staticClass: "dumSeeMore"
  }, [_vm._v("lihat detail >")])])]), _vm._v(" "), _c('div', {
    staticClass: "centerFlex"
  }, [_c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "haiFulan"
  }, [_c('b', [_vm._v("Hai Fulan,")])]), _vm._v(" "), _c('p', {
    staticClass: "gradeCapt"
  }, [_vm._v("Kelas 12")])]), _vm._v(" "), _c('img', {
    staticClass: "imagePP",
    attrs: {
      "src": _vm.pp
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "package-list"
  }, [_c('div', {
    staticClass: "alertTicket"
  }, [_c('span', [_vm._v("Kamu punya\n                          "), _c('b', {
    staticStyle: {
      "color": "#355eab"
    }
  }, [_vm._v("100 Paket Belajar")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#3cb54a"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dragmenuarea",
    attrs: {
      "id": "dragMenuSubmit"
    }
  }, [_c('div', {
    staticClass: "icDragMenu",
    on: {
      "click": function($event) {
        _vm.menuMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    staticStyle: {
      "color": "#3cb54a"
    }
  })]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "draggableMenuSubmit",
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "add": function($event) {
        return _vm.onMenuAdd($event)
      },
      "remove": function($event) {
        return _vm.onMenuRemove($event)
      }
    },
    model: {
      value: (_vm.submitMenu),
      callback: function($$v) {
        _vm.submitMenu = $$v
      },
      expression: "submitMenu"
    }
  }, 'draggable', _vm.dragOptionsMenu, false), [_c('transition-group', {
    staticClass: "transDragmenu"
  }, _vm._l((_vm.submitMenu), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "menuPreviewWrapper"
    }, [_c('img', {
      staticClass: "imgMenuPreview",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menuPreviewText"
    }, [_c('p', {
      staticClass: "menuPreviewName"
    }, [_vm._v("\n                                  " + _vm._s(element.name) + "\n                                ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(element.description))])])])])
  }), 0)], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "listdragMenuSection"
  }, [_c('span', {
    staticClass: "listmenuCapt"
  }, [_vm._v("List Menu")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "id": "draggableMenuSection",
      "move": _vm.onMove
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptionsMenu, false), [_c('transition-group', {
    staticClass: "transgrouplistdragmenusection"
  }, _vm._l((_vm.menuList), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "menuSectionWrapper"
    }, [_c('img', {
      staticClass: "imgMenuSection",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menuSectionText"
    }, [_c('p', {
      staticClass: "menuSectionName"
    }, [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.description))])])])])
  }), 0)], 1)], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-657ef424","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home_setting/preview_setting_content/Preview.vue
// module id = 1356
// module chunks = 0